import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useStatsTheme } from '../../v2/theme/statsTheme';

/**
 * Bouton standard cantera alignee sur le style v2 ActionButton (mais utilisable
 * hors contexte live/video). Supporte primary | secondary | ghost | danger.
 */
export default function CanteraButton({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  startIcon,
  endIcon,
  fullWidth,
  onClick,
  type = 'button',
  children,
  sx = {},
  ...rest
}) {
  const theme = useStatsTheme();

  const sizes = {
    sm: { height: 36, fontSize: 13, px: 1.5 },
    md: { height: 44, fontSize: 14, px: 2 },
    lg: { height: 52, fontSize: 15, px: 2.5 },
  };
  const s = sizes[size] || sizes.md;

  const variants = {
    primary: {
      bgcolor: theme.accent,
      color: '#fff',
      border: `1px solid ${theme.accent}`,
      '&:hover': {
        bgcolor: theme.accentStrong,
        borderColor: theme.accentStrong,
        boxShadow: theme.shadows.md,
      },
    },
    secondary: {
      bgcolor: theme.surfaces.floating,
      color: theme.text.primary,
      border: `1px solid ${theme.surfaces.border}`,
      '&:hover': {
        bgcolor: theme.accentSoft,
        borderColor: theme.accentBorder,
      },
    },
    ghost: {
      bgcolor: 'transparent',
      color: theme.text.primary,
      border: `1px solid ${theme.surfaces.border}`,
      '&:hover': {
        bgcolor: theme.accentSoft,
        borderColor: theme.accentBorder,
      },
    },
    danger: {
      bgcolor: theme.withAlpha(theme.actionColors.missed, 0.18),
      color: theme.actionColors.missed,
      border: `1px solid ${theme.withAlpha(theme.actionColors.missed, 0.45)}`,
      '&:hover': {
        bgcolor: theme.withAlpha(theme.actionColors.missed, 0.28),
      },
    },
  };

  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={!loading ? startIcon : undefined}
      endIcon={!loading ? endIcon : undefined}
      fullWidth={fullWidth}
      disableElevation
      sx={{
        height: s.height,
        fontSize: s.fontSize,
        fontWeight: 600,
        letterSpacing: '0.01em',
        textTransform: 'none',
        borderRadius: `${theme.radius.md}px`,
        px: s.px,
        transition: theme.motion.fast,
        ...variants[variant],
        '&.Mui-disabled': {
          opacity: 0.5,
          color: variants[variant].color,
        },
        ...sx,
      }}
      {...rest}
    >
      {loading ? <CircularProgress size={20} sx={{ color: 'inherit' }} /> : children}
    </Button>
  );
}
